
import React from "react";
import getLink from "./event-fn";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkedAlt } from "@fortawesome/free-solid-svg-icons";

//import * as moment from 'moment';
import dayjs from 'dayjs';

import "./event.scss";

library.add(faMapMarkedAlt);

const Event: React.FC<IEventProps> = ({ event: eventData }) => {
    return (
        <div className="event">
            <span className="date-time">
                <span className="container-top">
                    <span className="date-month-name">{dayjs(eventData.date).format("MMM")}</span>
                    <span className="date-day-number">{dayjs(eventData.date).format("D")}</span>
                    <span className="date-year">{dayjs(eventData.date).format("YYYY")}</span>
                </span>
                <span className="container-bottom">
                    <span className="title">{eventData.title}</span>
                    <span className="date-day-name">{dayjs(eventData.date).format("h:mm A")}&nbsp;{dayjs(eventData.date).format("dddd")}</span>
                    <span className="location-name">
                        {eventData.venue.venueUrl !== "" ? (
                            <a href={eventData.venue.venueUrl} target="_blank" rel="noopener noreferrer">{eventData.venue.venueTitle}</a>
                        ) : (
                            <div>{eventData.venue.venueTitle}</div>
                        )}
                    </span>
                    <span className="location-address">{eventData.venue.address}</span>
                    <span className="links">
                        {eventData.venue.mapUrl !== "" ? (
                            <div className='map-link'>
                                <FontAwesomeIcon className="fa-0.25x" icon={["fas", "map-marked-alt"]} />&nbsp;                        
                                <a href={getLink(eventData.venue.mapUrl)} target="_blank" rel="noopener noreferrer">
                                    Open in Google Maps
                                </a>
                            </div>
                        ) : ("")
                        }
                    </span>
                </span>
            </span>

        </div>
    )
}

export default Event;